import { TextProps } from '@bonanza-social/moonlight/lib/common/Text/Text.types';
import { BottomSheet } from '../BottomSheetsManager/BottomSheetsManager';

export function openMaintenanceSheet(
  locNS: TextProps['locNS'],
  locKey: TextProps['locKey'],
) {
  BottomSheet.open({
    namespace: 'common',
    type: 'Maintenance',
    data: {
      textNS: locNS,
      textKey: locKey,
    },
  });
}
